import axios from 'axios'
const request = axios.create({
  baseURL: 'http://www.yzltjt.com',
  timeout: 6000  // 增加到6秒
})
export default request



// WEBPACK FOOTER //
// ./src/ApI/request.js